<template>
  <div class="add_billing_information">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/BillingInformation' }"
          >企业增值税开票信息</el-breadcrumb-item
        >
        <el-breadcrumb-item>新增开票信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
        <table border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>单位名称:</td>
            <td>
              <el-form-item label="" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入单位名称"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>纳税人识别码:</td>
            <td>
              <div class="input_code">
                <el-form-item label="" prop="code">
                  <el-input
                    v-model="form.code"
                    placeholder="请输入纳税人识别号"
                  ></el-input
                ></el-form-item>
                <span>字母需大写，字符之间不要填写空格</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>是否一般纳税人:</td>
            <td>
              <el-form-item label="" prop="isTaxpayer">
                <el-radio-group v-model="form.isTaxpayer">
                  <el-radio label="1">是</el-radio>
                  <el-radio label="2">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>注册地址:</td>
            <td>
              <el-form-item label="" prop="area">
                <el-input
                  v-model="form.area"
                  placeholder="请输入注册地址"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>联系电话:</td>
            <td>
              <el-form-item label="" prop="phone">
                <el-input
                  v-model="form.phone"
                  placeholder="请输入联系电话"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>企业联系人:</td>
            <td>
              <el-form-item label="" prop="linkman">
                <el-input
                  v-model="form.linkman"
                  placeholder="请输入企业联系人"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>开户行:</td>
            <td>
              <el-form-item label="" prop="bank">
                <el-input
                  v-model="form.bank"
                  placeholder="请输入开户行"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>银行账户:</td>
            <td>
              <el-form-item label="" prop="bankNumber">
                <el-input
                  v-model="form.bankNumber"
                  placeholder="请输入银行账户"
                ></el-input
              ></el-form-item>
            </td>
          </tr>
          <tr>
            <td>备注:</td>
            <td>
              <p>
                1、根据增值税发票管理条例，凡有发票遗失或毁损，将不得重开，我中心可以提供发票存根联复印件，并加盖发票专用章，税务局认可抵扣。
              </p>
              <p>
                2、小规模纳税人只提供“增值税普通发票”，请在是否一般纳税人处选“否”。
              </p>
              <p>
                3、一般纳税人如需增值税普通发票，请在是否一般纳税人处选“否”。
              </p>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="footer">
        <el-button @click="returnBack">返回</el-button>
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { httpCreate } from "../../utils/personalsetting";

export default {
  data() {
    //手机号格式校验
    const phoneCheck = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (!reg.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        this.isphone = true;
        callback();
      }
    };
    //纯数字验证
    const isNum = (rule, value, callback) => {
      let age = /^[0-9]*$/;
      if (age.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确银行账号"));
      }
    };
    return {
      form: {
        name: "",
        code: "",
        isTaxpayer: "",
        area: "",
        phone: "",
        linkman: "",
        bank: "",
        bankNumber: "",
      },
      rules: {
        name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        code: [
          { required: true, message: "请输入纳税人识别码", trigger: "blur" },
        ],
        isTaxpayer: [
          {
            required: true,
            message: "请选择是否一般纳税人",
            trigger: "change",
          },
        ],
        area: [{ required: true, message: "请输入注册地址", trigger: "blur" }],
        phone: [{ required: true, validator: phoneCheck, trigger: "blur" }],
        linkman: [
          { required: true, message: "请输入企业联系人箱", trigger: "blur" },
        ],
        bank: [{ required: true, message: "请输入开户行", trigger: "blur" }],
        bankNumber: [
          { required: true, validator: isNum, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    //返回
    returnBack() {
      this.$router.go(-1);
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            enterprise_name: this.form.name,
            organization_code: this.form.code,
            is_enterprise: this.form.isTaxpayer,
            register_address: this.form.area,
            contact_phone: this.form.phone,
            contact_name: this.form.linkman,
            bank_name: this.form.bank,
            bank_number: this.form.bankNumber,
          };
          this._httpCreate(data);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //新增增值税开票信息
    _httpCreate(page, pagesize, enterprise) {
      httpCreate(page, pagesize, enterprise).then((res) => {
        let data = res.data;
        if (data.code == 0) {
          this.$message.success(data.data);
          this.$router.push("/billingInformation");
        } else {
          this.$message(data.msg);
        }
      });
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.add_billing_information {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    table {
      width: 100%;
      height: 200px;
      margin-top: 20px;
      border: 1px solid #eee;
      tr {
        td {
          height: 70px;
          padding: 0 15px;
          p {
            margin: 20px;
            line-height: 20px;
          }
          /deep/ .el-input {
            width: 30%;
            border-radius: 0px !important;
          }
          /deep/ .el-form-item {
            margin-bottom: 0 !important;
          }
          /deep/ .el-form-item__error {
            padding-top: 0 !important;
          }
          .input_code {
            position: relative;
            span {
              position: absolute;
              left: 30%;
              top: 50%;
              transform: translateY(-50%);
              margin-left: 10px;
            }
          }
        }
        td:first-of-type {
          width: 30%;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>